export const regex = RegExp(
  '\\s?(-?[0-9]*\\.[0-9]*\\s*?),\\s?(-?[0-9]*\\.[0-9]*\\s*?)'
);
const AXIS_VALUE = 'Value';
const AXIS_VALUE_DISTRIBUTION = 'Value Distribution';
const AXIS_AMOUNT_DISTRIBUTION = 'Amount Distribution';
const AXIS_VALUE_PERIOD = 'Value Over Period';
const AXIS_AMOUNT_PERIOD = 'Amount Over Period';
const AXIS_AMOUNTS = 'Amount($)';
const AXIS_Y_FREQUENCY_PEER_COMPARISION = 'Frequency';

export const riskIndicatorNameMap = {
  'Historical comparison of average incoming amount': {
    peer_comparison: {
      xAxisValue: 'Distrbn - Avg I/C Amt Ratio',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Avg I/C Amt Ratio',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly volume of ATM cash withdrawals': {
    peer_comparison: {
      xAxisValue: 'Withdrawal Vol Distrbn',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Withdrawal Volume',
      xAxisValue: 'Time Period'
    }
  },
  'Historical comparison of average outgoing amount': {
    peer_comparison: {
      xAxisValue: 'Distrbn - Avg O/G Amt Ratio',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Avg O/G Amt Ratio',
      xAxisValue: 'Time Period'
    }
  },
  'Historical comparison of total incoming amount': {
    peer_comparison: {
      xAxisValue: 'Distrbn - Total I/C Amt Ratio',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Total I/C Amt Ratio',
      xAxisValue: 'Time Period'
    }
  },
  'Historical comparison of total outgoing amount': {
    peer_comparison: {
      xAxisValue: 'Distrbn - Total O/G Amt Ratio',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Total O/G Amt Ratio',
      xAxisValue: 'Time Period'
    }
  },
  'Flux indicator of fund transfer': {
    peer_comparison: {
      xAxisValue: 'Flux Distribution',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Flux',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly amount of CDM deposits': {
    peer_comparison: {
      xAxisValue: 'Deposit Amt Distrbn ($)',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Deposit Amount ($)',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly amount of ATM cash withdrawals': {
    peer_comparison: {
      xAxisValue: 'Withdrawal Amt Distrbn ($)',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Withdrawal Amount ($)',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly volume of CDM deposits': {
    peer_comparison: {
      xAxisValue: 'Deposit Vol Distrbn',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Deposit Volume',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly volume of cash withdrawals': {
    peer_comparison: {
      yAxisValue: 'Distribution of Customers (%)',
      xAxisValue: 'Withdrawal Vol Distrbn'
    },
    profile_deviation: {
      yAxisValue: 'Withdrawal Volume',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly amount of incoming overseas fund transfer': {
    peer_comparison: {
      xAxisValue: 'I/C FT Distribution ($)',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'I/C FT Amount ($)',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly amount of outgoing overseas fund transfer': {
    peer_comparison: {
      xAxisValue: 'O/G FT Distribution ($)',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'O/G FT Amount ($)',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly amount of incoming fund transfer from high risk country': {
    peer_comparison: {
      yAxisValue: 'Distribution of Customers (%)',
      xAxisValue: 'I/C FT to HRC ($)'
    },
    profile_deviation: {
      yAxisValue: 'I/C FT to HRC ($)',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly amount of incoming fund transfer from risk country': {
    peer_comparison: {
      yAxisValue: 'Distribution of Customers (%)',
      xAxisValue: 'Distrbn – I/C FT from HRC ($)'
    },
    profile_deviation: {
      yAxisValue: 'I/C FT from HRC ($)',
      xAxisValue: 'Time Period'
    }
  },
  'Monthly amount of outgoing fund transfer to high risk country': {
    peer_comparison: {
      yAxisValue: 'Distribution of Customers (%)',
      xAxisValue: 'Distrbn - O/G FT to HRC ($)'
    },
    profile_deviation: {
      yAxisValue: 'O/C FT to HRC ($)',
      xAxisValue: 'Time Period'
    }
  },
  'Average card payment amount in 90 days': {
    peer_comparison: {
      xAxisValue: 'Pymt Amt Distrbn ($)',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Payment Amount ($)',
      xAxisValue: 'Time Period'
    }
  },
  'Average card payment amount in 180 days': {
    peer_comparison: {
      xAxisValue: 'Pymt Amt Distrbn ($)',
      yAxisValue: 'Distribution of Customers (%)'
    },
    profile_deviation: {
      yAxisValue: 'Payment Amount ($)',
      xAxisValue: 'Time Period'
    }
  }
};

export const deviation_down =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAQCAYAAADnEwSWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD9SURBVHgBtdFPCoJQEAbwGVu16ygtahFEuLRdN6gbRCfIbtANqhu0dFdEUFDQFbpH6vR8mPlnnk6hH0SMDt+PQQAV5zZaRj9oOKiRkFw9Weh6/dMKGooFfojJpNAmL9SQcxm66qovIrzQuY+m0b/XO+1AkOSqX0ENBbTVQwtnEhAzBUIwA30iALFQVAGykBBE7qEJLEAhreL3yyrQftgdFuNAAtir5Uka8gZnl9vNgxHU9oONEWNLGMi4G4MaeoUHIuqUYmwJA5l2kWCh5qmCump8VmKZkhLIBKYiw+ISW0FHye74OlwT4vxvTJrUN+rmMQtqTAmkUxtWBUV5Axrxq9XDdWNvAAAAAElFTkSuQmCC';
export const deviation_up =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAALCAYAAACQy8Z9AAAAAXNSR0IArs4c6QAAAbhJREFUKBWlkL9LI0Ecxec72eW4xAXlXNPYiGAhHvijuuZqwcrIkEIUEVTuFIsTO1FBC0FEuEJQBANyRdC1OK4ULdQ/QAkoYiU2myBKRIzZ7IxvAsqqi+A5sDsz7/uZN2++jH1guMlk/Y0Q9ksLeim8Z+8mEluKsU6YnGI+4PgU0e6HTHPJZIPveUcI8ikQJgvz/x92On3Kif4GHZDy0AgKwXVOiA6lVJNNtEgbG8VgTa+vhai79/0lqVT7sxrR/ivTy+7u2tLd3W/f9zs1nGUshmny8aCanjZymcxYQcopaJ+J6ArPXfWVGtcMenrw1FMlRMSVcoSUmkHTLRRuwFQA8gzDaK5Op49dIb4xKZfxgq/aAMyfaCz2y1pfz7pdXWuQeojzyrIpGt4qS6UVwG1lmMjhpjkqPW8K2iCgfUaUYUoN4UKEozNwP+KOs615PfK9vV8Kt7cDNY4zR9lE4jvS7OBwBPh5hGjY3tz8p8Grvr7KYj5/AqO43qNexFPnbcuapVSqUNZCflyaZhGHLhB7IR6NNj4aarYqlbpmnP9E0hLS7ZmctyDJxFuGIXeES7n+fiu8Eq4+AJBwoxZ8aeJcAAAAAElFTkSuQmCC';
